/** Format API last_activity for the conversations table (e.g. 7/11/19). */
export function formatConversationLastActivity(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "2-digit",
  });
}

/** Map API conversation object → UI row used by TicketV2 History. */
export function mapConversationToRow(c) {
  if (!c || typeof c !== "object") return null;
  const id = c.id || c._id || "";
  const numberRaw = c.number != null ? String(c.number) : String(id);
  const numberDisplay =
    numberRaw.length > 8 ? `#${numberRaw.slice(-4)}` : numberRaw.startsWith("#") ? numberRaw : `#${numberRaw}`;

  return {
    id: String(id),
    subject: c.title || c.subject || "Untitled",
    snippet: c.snippet || "",
    type: c.type_label || (c.type === "live_chat" ? "Live Chat" : "Ticket"),
    typeKey: c.type || "",
    status: c.status_label || c.status || "",
    statusKey: String(c.status || "").toLowerCase(),
    assignedTo: c.assigned_to?.name || c.assignedTo || "—",
    number: numberDisplay,
    lastActivity: formatConversationLastActivity(c.last_activity || c.lastActivity),
    isCurrent: Boolean(c.is_current),
  };
}

export function mapConversationsToRows(list) {
  if (!Array.isArray(list)) return [];
  return list.map(mapConversationToRow).filter(Boolean);
}
